module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-layout', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Kullanıcılar")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Adı Soyadı")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v("Durumu")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/users/save',
          query: {
            id: item.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    }), _vm._v(" " + _vm._s(item.name) + " " + _vm._s(item.surname))])], 1), _vm._v(" "), _c('td', [_c('label', {
      staticClass: "tag",
      class: {
        'tag-warning': item.status == 0, 'tag-success': item.status == 1
      }
    }, [(item.status == 1) ? _c('span', [_vm._v("Aktif")]) : _vm._e(), _vm._v(" "), (item.status == 0) ? _c('span', [_vm._v("Pasif")]) : _vm._e()])])])
  }), _vm._v(" "), (!_vm.items) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n                                            Herhangi bir kayıt bulunmamakta.\n                                        ")])])]) : _vm._e()], 2)])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06126c70!./~/vue-loader/lib/selector.js?type=template&index=0!./public/src/pages/users.vue
// module id = 335
// module chunks = 0